import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import Loader from '../Loader';
import { useParams } from 'react-router-dom'

const ClientUsers = () => {

  const [user, setUser] = useState([]);
  const [searchUserEmail, setSearchUserEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [count, setCount] = useState(0)
  const [total, setTotal] = useState(0)
  const { id } = useParams()

  // Fetch All users
  const getUser = useCallback(async (offset, limit, email) => {
    try {
      let query = `&offset=${offset}&limit=${limit}`

      if (email) {
        query += `&email=${email}`
      }

      const response = await axios.get(`/clients/users/?client_id=${id}${query}`);
      setUser(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError("Network error! Check your connection.");
      } else if (error.response.status) {
        setError(error.response.data.detail)
      } else if (error.response.status >= 500) {
        setError("Server error! Please try again later.");
      } else {
        setError("An unexpected error occurred!");
      }
    }
  }, [id]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLoading(true);
      getUser((currentPage - 1) * recordsPerPage, recordsPerPage, searchUserEmail);
    }, 1000);
    return () => clearTimeout(timerId);
  }, [currentPage, recordsPerPage, searchUserEmail, getUser]);


  // search user by email
  const handleSearchChange = (e) => {
    setSearchUserEmail(e.target.value);
    setCurrentPage(1);
  };


  return (
    <div className='my-2'>
      <div className='bg-white rounded-lg p-4 w-full flex-1 min-w-0'>
        <div className='flex flex-wrap items-center justify-between py-3'>
          <h5 className='text-[#165277] font-bold'>Showing {count} / {total} Users</h5>
          <div className='py-2'>
            <form>
              <label htmlFor='search'><span className='hidden'>Search</span>
                <input
                  type='search'
                  id='search'
                  className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                  required
                  placeholder='Search email'
                  value={searchUserEmail}
                  onChange={handleSearchChange}
                />
              </label>
            </form>
          </div>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#e9f3f9] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#e9f3f9] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          <div className='overflow-x-auto rounded-lg'>
            {user.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>No</th>
                      <th className='p-2'>First Name</th>
                      <th className='p-2'>Last Name</th>
                      <th className='p-2'>Email</th>
                      <th className='p-2'>Phone</th>
                      <th className='p-2'>Role</th>
                      <th className='p-2'>Created At</th>
                      <th className='p-2'>Updated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user.map((users) => (
                      <tr key={users.id}>
                        <td className='p-2 '>{users.id}</td>
                        <td className='p-2'>{users.first_name}</td>
                        <td className='p-2'>{users.last_name}</td>
                        <td className='p-2'>{users.email}</td>
                        <td className='p-2'>{users.phone}</td>
                        <td className='p-2'>{users.role}</td>
                        <td className='p-2'>{new Date(users.created_at).toLocaleString("en-CA", { hour12: false })}</td>
                        <td className='p-2'>{new Date(users.updated_at).toLocaleString("en-CA", { hour12: false })}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#e9f3f9] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default ClientUsers;
